import angular from 'angular';

class ModalUnUpdatePdpCtrl {

    close() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalUnUpdatePdp', {
    templateUrl: require('./modal-unupdated-platform-partner-history.html'),
    controller: ModalUnUpdatePdpCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
